import { REMOVE_TOAST, REMOVE_TOASTS } from './constants'

export function removeToast(id, isMessage) {
    return {
        type: REMOVE_TOAST,
        payload: { id, isMessage, dismissed: +new Date() },
    }
}

export function removeToasts(ids) {
    return {
        type: REMOVE_TOASTS,
        payload: { ids, dismissed: +new Date() },
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/actions.js